import {http} from '../../plugins/http';

export default {
    store(params) {
        return http.post(`/api/v1/reminders`, params);
    },

    update(reminder, params) {
        if (reminder) {
            return http.patch(`/api/v1/reminders/${reminder}`, params);
        } else {
            return http.patch(`/api/v1/reminders`, params);
        }
    },

    cloneReminder(params) {
        http.post(`/api/v1/reminders/clone-reminder`, params);
    },

    getReminders() {
        return http.get(`/api/v1/reminders/getReminders`);
    },

    destroy(reminder) {
        return http.delete(`/api/v1/reminders/${reminder}`);
    },

    destroyRepeat(event, params) {
        return http.post(`/api/v1/reminders/destroy-repeat/${event}`, params);
    }
};



// WEBPACK FOOTER //
// ./src/services/Reminders/ReminderController.js